<template>
    <div class="header-analytics-item">
        <router-link 
            :to="headerAnalyticsItem.route"
            class="header-analytics-item__link"
        >
            {{headerAnalyticsItem.name}}
        </router-link>
    </div>
</template>

<script>
export default {
    name: 'HeaderAnalyticsItem',
    /**
     * входные данные компонента
     * @property {object} headerAnalyticsItem - элемент хедера
     */
    props: {
        headerAnalyticsItem: {
            type: Object,
            default: () => ({})
        }
    }
}
</script>

<style lang="scss" scoped>
    .header-analytics-item {
        margin-right: 5px;
    }
    .header-analytics-item__link {
        text-decoration: none;     
        color: #b0b1b4;
        height: 32px;
        align-items: center;
        display: flex;
        border-radius: 100px;
        transition: .3s;
        border: 1px solid transparent;
        white-space: nowrap;
        padding: 0 20px;
    }
    .header-analytics-item__link:hover {
        color: #fe1060;
        border-color: #fe1060;
    }
    .router-link-active {
        color: #000;
        background: #fe1060;
        pointer-events: none;
    }
</style>